import { type ReactNode } from 'react';
import { TopBar } from './TopBar';
import { SideNav } from './SideNav';
import './AppLayout.css';

interface AppLayoutProps {
  children: ReactNode;
}

export function AppLayout({ children }: AppLayoutProps) {
  return (
    <div className="app-layout">
      <TopBar />
      <div className="app-layout__body">
        <SideNav />
        <main className="app-layout__main">{children}</main>
      </div>
    </div>
  );
}
